import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { Capacitor } from '@capacitor/core';

// Solo app nativa: blocco lo zoom del viewport (pinch e auto-zoom iOS al focus dei
// campi con font < 16px). Un'app nativa non deve zoomare; sul web invece il pinch
// resta abilitato per accessibilità, quindi il meta in index.html non va toccato.
if (Capacitor.isNativePlatform()) {
  const viewportMeta = document.querySelector('meta[name="viewport"]');
  if (viewportMeta) {
    viewportMeta.setAttribute(
      'content',
      'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover'
    );
  }
}

// Supporto pre-rendering via react-snap:
// - se il DOM contiene già un albero (HTML statico pre-renderizzato), idratiamo
// - altrimenti rendering client-side standard
const rootElement = document.getElementById('root');
const tree = (
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, tree);
} else {
  createRoot(rootElement).render(tree);
}
